// The single transport function. Maps non-2xx responses to typed errors.

import { apiBaseUrl } from '../config';
import { ApiError, RateLimitError, ValidationError } from './errors';

export interface RequestOptions {
  method?: 'GET' | 'POST';
  body?: unknown;
}

export async function request<T>(path: string, opts: RequestOptions = {}): Promise<T> {
  const hasBody = opts.body !== undefined;
  const init: RequestInit = {
    method: opts.method ?? 'GET',
    headers: hasBody ? { 'content-type': 'application/json' } : {},
  };
  if (hasBody) init.body = JSON.stringify(opts.body);

  const res = await fetch(`${apiBaseUrl}${path}`, init);
  if (res.status === 204) return undefined as T;

  const data: unknown = await res.json().catch(() => ({}));
  if (!res.ok) {
    const message = (data as { error?: string }).error ?? res.statusText;
    if (res.status === 429) throw new RateLimitError(message);
    if (res.status === 400) throw new ValidationError(message);
    throw new ApiError(res.status, message);
  }
  return data as T;
}
